import { connect } from 'react-redux'
import { createSelector } from 'reselect'

// Components
import { Entity, Shelf } from '@tracklib/kit'
import Cover from 'components/collection/cover'

// Types
import { Collection, EntityState } from 'types'

// Selectors
import { authDomain, collectionEntities } from 'selectors'

import styles from './collectionsblock.css'

type CollectionsBlockProps = {
  collections: EntityState<Collection>
  value: {
    collections: [
      {
        owner: string
        collection: number
      },
    ]
    heading: string
    show_more_text: string
  }
}

const CollectionsBlock = ({
  value: { collections: collectionsList, heading, subheading, show_more_text: showMoreText },
  collections,
}: CollectionsBlockProps): JSX.Element => {
  if (!Object.keys(collections).length) {
    return null
  }
  return (
    <Shelf
      heading={heading}
      subheading={subheading}
      linkText={showMoreText}
      linkUrl="/collections/"
      showMoreDatatesting="collections_header_frontpage"
      className={`${styles.shelf} collectionsBlock`}
      size="small"
    >
      {collectionsList.slice(0, 4).map(col => {
        const collection = collections[String(col.collection)]
        if (!collection) {
          return null
        }
        return (
          <Shelf.Item key={collection.id}>
            <Entity
              title={collection.title}
              owner={col.owner || collection.owner_name}
              image={<Cover collection={collection} datatesting="collectionsblock_cover" />}
              backgroundColor="transparent"
              url={`/collection/${collection.id}`}
              type={collection.loop_collection ? 'Loop collection' : 'Collection'}
            />
          </Shelf.Item>
        )
      })}
    </Shelf>
  )
}

const mapStateToProps = createSelector([collectionEntities, authDomain], (collections, auth) => ({
  collections,
  isAuthenticated: auth.isAuthenticated,
}))

export { CollectionsBlock as Component }
export default connect(mapStateToProps)(CollectionsBlock)
